import CustomerServicesKenya from './CustomerServicesKenya';
import './CustomerServiceKenya.css';

/** App shell wrapper — sidebar/auth come from App.js; dashboard UI is in CustomerServicesKenya. */
function CustomerServiceKenya() {
  return (
    <div className="csk-page">
      <div className="csk-scroll">
        <div className="csk-panel csk-panel--fill">
          <CustomerServicesKenya />
        </div>
      </div>
    </div>
  );
}

export default CustomerServiceKenya;
